import { Backdrop, CircularProgress } from "@mui/material";

export interface ILoaderProps {
  inline?: boolean;
}

export function Loader({ inline }: ILoaderProps) {
  if (inline) return <CircularProgress color="primary" />;

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
